import { Routes } from '@angular/router';
import { authGuard, permissionGuard } from '@core/auth/auth.guard';

/**
 * Routing du socle IDRA. Chaque « tête » (module) est chargée en lazy-loading
 * et protégée par une permission dédiée gérée côté back (spatie/laravel-permission).
 */
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout').then((m) => m.MainLayout),
    canActivate: [authGuard],
    children: [
      {
        // Hub d'accès aux modules — page d'accueil, accessible à tout utilisateur connecté.
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('@features/hub/hub').then((m) => m.Hub),
      },
      {
        // Cible de permissionGuard — volontairement sans guard de permission.
        path: 'acces-refuse',
        loadComponent: () => import('./layout/forbidden').then((m) => m.Forbidden),
      },
      {
        path: 'id-mail',
        canActivate: [permissionGuard],
        data: { permission: 'id-mail.access' },
        loadChildren: () =>
          import('@features/id-mail/id-mail.routes').then((m) => m.ID_MAIL_ROUTES),
      },
      {
        path: 'id-anadoc',
        canActivate: [permissionGuard],
        data: { permission: 'id-anadoc.access' },
        loadChildren: () =>
          import('@features/id-anadoc/id-anadoc.routes').then((m) => m.ID_ANADOC_ROUTES),
      },
      {
        path: 'id-call',
        canActivate: [permissionGuard],
        data: { permission: 'id-call.access' },
        loadChildren: () =>
          import('@features/id-call/id-call.routes').then((m) => m.ID_CALL_ROUTES),
      },
      {
        // Administration du socle (logs, connexions, clients API) — hors têtes ID.xxx.
        // Chaque section porte sa propre permission dans admin.routes.ts.
        path: 'admin',
        loadChildren: () => import('@features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
